import { getAssets } from "@unisearch/helpers";
import Link from "next/link";
import { AiOutlineClockCircle } from "react-icons/ai";
import VideoMeta from "../video_meta";
import styles from "./video_box_grid.module.scss";

const VideoBoxGrid = (props) => {
  const { spanTwo, colorWhite, metaTop, metaBottom, showCategory } = props;

  return (
    <article
      className={`${styles.box_grid} ${spanTwo ? `${styles.span_two}` : ""} `}
    >
      <div className={styles.video_thumbnail}>
        {/* {props.video && ( */}
        <Link legacyBehavior href="#">
          <a className={styles.video_popup}></a>
        </Link>
        {/* )} */}
        <Link legacyBehavior href="#">
          <a>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/blog/blog1.png")}
                alt="video thumbnail"
              />
            </div>
          </a>
        </Link>
        <div className={styles.watch_later}>
          <AiOutlineClockCircle />
          <span>Watch Later</span>
        </div>
        <div className={styles.duration}>9:15</div>
        {metaTop && (
          <div className={styles.meta_wrapper}>
            <VideoMeta />
          </div>
        )}

        <div className={styles.icon}>
          <Link legacyBehavior href="#">
            <a></a>
          </Link>
        </div>
      </div>

      <div className={styles.video_info}>
        {showCategory && (
          <Link legacyBehavior href="#">
            <a>
              <div className={styles.video_cat_title}>Study in the UK</div>
            </a>
          </Link>
        )}

        <Link legacyBehavior href="#">
          <a>
            <h3
              className={`${styles.video_title} ${
                colorWhite ? `${styles.color_white}` : ""
              } `}
            >
              Difference Between September and January Intake in UK
            </h3>
          </a>
        </Link>
        {metaBottom && (
          <div className={styles.meta_bottom_wrapper}>
            <VideoMeta />
          </div>
        )}
      </div>
    </article>
  );
};

export default VideoBoxGrid;
